import React, { useEffect, useRef } from 'react';

import cx from 'classnames';
import { useLottie } from './LottieContext';

export interface LottieLayerProps {
  className?: string;

  /**
   * Data loaded from a JSON Lottie file
   */
  data: Record<string, unknown>;

  /**
   * Whether the animation should play automatically
   *
   * @default true
   */
  autoplay?: boolean;

  /**
   * Whether the animation should loop
   *
   * @default true
   */
  loop?: boolean;
}

export const LottieLayer = ({
  className,
  data,
  loop = false,
  autoplay = true,
}: LottieLayerProps) => {
  const lottieContainerRef = useRef<HTMLDivElement>(null);
  const lottie = useLottie();
  useEffect(() => {
    if (lottie && lottieContainerRef.current) {
      lottie.loadAnimation({
        container: lottieContainerRef.current,
        animationData: data,
        renderer: 'svg',
        loop,
        autoplay,
      });
    }
  }, [data, lottie, autoplay, loop]);
  return <div className={cx(className)} ref={lottieContainerRef} />;
};
